import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=d31db43e&scoped=true"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=d31db43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31db43e",
  null
  
)

export default component.exports